// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__uiO93","button-wrapper":"button-wrapper__3VsY9","button":"button__2nfIM","warning_wrapper":"warning_wrapper__15TOH"};